import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { LanguageProvider } from './i18n/LanguageContext';
render(<LanguageProvider data-id="element-283">
    <App data-id="element-284" />
  </LanguageProvider>, document.getElementById('root'));